import * as THREE from 'three'; // 👈 Añade esto al principio de todo

import { svg } from "../icons.js";

export function buscarArrecife(nombre) {
var array_madre = {
  reefs:[
        {



          "nombre_arrefice": "Palancar-Bricks",
          "position_camera_x":-0.41607259894049,
          "position_camera_y":0.05562320988104033,
          "position_camera_z":0.34394038853313924,
          "target_camera_x":-0.16383135110345423,
          "target_camera_y":-0.17557065901527102,
          "target_camera_z":-0.020646703770428616,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Bricks",
          "depth": "50–90 ft (15–27 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.328018372996148,-87.02716427105143",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.39","Y":"-0.01","Z":"0.25","depth":"2.24","time":10}]
        },
        {



          "nombre_arrefice": "Santa-Rosa-Wall",
          "position_camera_x":-0.43042507612888514,
          "position_camera_y":0.03360912665108201,
          "position_camera_z":0.15163871927926428,
          "target_camera_x":0.02442232885187777,
          "target_camera_y":-0.13175344286233714,
          "target_camera_z":0.026063806234558617,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Santa-Rosa-Wall",
          "depth": "50–120 ft (15–36 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.37800661313823, -87.02955680149329",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.38","Y":"-0.01","Z":"0.11","depth":"2.39","time":10}]
        },
        {


          "nombre_arrefice": "Palancar-Gardens",
          "position_camera_x":-0.4163716687130561,
          "position_camera_y":0.03842547209568209,
          "position_camera_z":0.3233393050544095,
          "target_camera_x":-0.25219442956616617,
          "target_camera_y":-0.1808163066256967,
          "target_camera_z":-0.09496546016969233,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Gardens",
          "depth": "25–60 ft (7–18 m)",
          "level": "Beginner to intermediate",
          "location": "20.332931663243645, -87.02688294545014",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.40","Y":"0.01","Z":"0.22","depth":"1.86","time":10}]
        },
        {




          "nombre_arrefice": "Colombia-Regular",
          "position_camera_x":-0.44570371495875555,
          "position_camera_y":0.03502478813756629,
          "position_camera_z":0.24755000693041135,
          "target_camera_x":-0.042881780132327345,
          "target_camera_y":-0.14631967380281644,
          "target_camera_z":0.4817479466016345,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Colombia-Regular",
          "depth": "20–80 ft (6–24 m)",
          "level": "Beginner to intermediate & advanced",
          "location": "20.314981756963245, -87.02583908047819",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.38","Y":"-0.01","Z":"0.26","depth":"2.13","time":10}]
        },
        {


          "nombre_arrefice": "Palancar-Caves",
          "position_camera_x":-0.44794156431381105,
          "position_camera_y":0.05013485948080476,
          "position_camera_z":0.2305171515382887,
          "target_camera_x":-0.07948896385111082,
          "target_camera_y":-0.19390901156313883,
          "target_camera_z":0.4643659706889546,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Caves",
          "depth": "25–60 ft (7–18 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.32477127026768, -87.02682613337994",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.39","Y":"-0.01","Z":"0.24","depth":"1.98","time":10}]
        },
        {


          "nombre_arrefice": "El-Cedral",
          "position_camera_x":-0.41116944664195987,
          "position_camera_y":0.030737512465848965,
          "position_camera_z":0.19925189053400075,
          "target_camera_x":-0.2163187110031696,
          "target_camera_y":-0.1808163066257172,
          "target_camera_z":-0.20974465278732754,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/El-Cedral",
          "depth": "40–70 ft (12–21 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.365633902861198, -87.02964812128249",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.39","Y":"-0.01","Z":"0.15","depth":"1.84","time":10}]
        },
        {


          "nombre_arrefice": "Dalila-Francesa",
          "position_camera_x":-0.4375411386833117,
          "position_camera_y":0.0362353631471998,
          "position_camera_z":0.14841312950799113,
          "target_camera_x":-0.16238433279269393,
          "target_camera_y":-0.1808163066257062,
          "target_camera_z":0.505032401029969,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Dalila-Francesa",
          "depth": "40–70 ft (12–21 m)",
          "level": "Beginner to intermediate",
          "location": "20.34618105131649, -87.02800247808796",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.39","Y":"-0.01","Z":"0.17","depth":"1.54","time":10}]
        },



        {
          "nombre_arrefice": "La-Francesa",
          "position_camera_x":-0.42116160280825055,
          "position_camera_y":0.03073751324931423,
          "position_camera_z":0.25246813315621486,
          "target_camera_x":-0.22631086058358896,
          "target_camera_y":-0.18081630662571452,
          "target_camera_z":-0.1565284066222804,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/La-Francesa",
          "depth": "30–60 ft (9–18 m)",
          "level": "Beginner to intermediate",
          "location": "20.35634187018184, -87.02865161645796",
          "medidas_largo": 750,
          "rutas": []
        },
        {



          "nombre_arrefice": "Yucab",
          "position_camera_x":-0.3690224055221665,
          "position_camera_y":0.02568437399878301,
          "position_camera_z":0.03915083074497788,
          "target_camera_x":0.0009488794727786937,
          "target_camera_y":-0.09904574280030506,
          "target_camera_z":-0.27320096810125083,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Yucab",
          "depth": "30–50 ft (9–15 m)",
          "level": "Beginner",
          "location": "20.419276781068966, -87.01832877872715",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.34","Y":"-0.01","Z":"0.02","depth":"1.30","time":10}]
        },
        {




          "nombre_arrefice": "Tormentos",
          "position_camera_x":-0.3690224055221665,
          "position_camera_y":0.02568437399878301,
          "position_camera_z":0.03915083074497788,
          "target_camera_x":0.0009488794727786937,
          "target_camera_y":-0.09904574280030506,
          "target_camera_z":-0.27320096810125083,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Tormentos",
          "depth": "40–70 ft (12–21 m)",
          "level": "Beginner",
          "location": "20.42782302681176, -87.01455222847696",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.33","Y":"0.02","Z":"0.01","depth":"1.19","time":10}]
        },
        {
          "nombre_arrefice": "Cardona",
          "position_camera_x":-0.616316181165592,
          "position_camera_y":0.05009514227443956,
          "position_camera_z":0.45262876270127916,
          "target_camera_x":-0.2320925802952665,
          "target_camera_y":-0.030462302791403023,
          "target_camera_z":0.1429848639964359,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Cardona",
          "depth": "40–70 ft (12–21 m)",
          "level": "Beginner",
          "location": "20.42782302681176, -87.01455222847696",
          "medidas_largo": 750,
          "rutas": []
        },
        {


          "nombre_arrefice": "Chankanab",
          "position_camera_x":-0.3073443014303321,
          "position_camera_y":0.0245979015465295,
          "position_camera_z":-0.052032915841298655,
          "target_camera_x":-0.40270352164285983,
          "target_camera_y":-0.08002134384277063,
          "target_camera_z":0.4275099360429771,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Chankanab",
          "depth": "20–40 ft (6–12 m)",
          "level": "Beginner",
          "location": "20.441817735639003, -87.00043308035178",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.32","Y":"-0.01","Z":"-0.01","depth":"0.67","time":10}]
        },
        {



          "nombre_arrefice": "Paraiso",
          "position_camera_x":-0.2322829658306286,
          "position_camera_y":0.03917793048648311,
          "position_camera_z":-0.1509093147848935,
          "target_camera_x":-0.41190866057761527,
          "target_camera_y":-0.051656127610148844,
          "target_camera_z":0.3067846699651358,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Paraiso",
          "depth": "20–40 ft (6–12 m)",
          "level": "Beginner",
          "location": "20.468952065438124, -86.98345874116492",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.25","Y":"0.02","Z":"-0.10","depth":"1.01","time":10}]
        },
        {

          
          "nombre_arrefice": "Villa-Blanca",
          "position_camera_x":-0.21033511822749076,
          "position_camera_y":0.02662787406986953,
          "position_camera_z":-0.1776516204432656,
          "target_camera_x":-0.38738445042338,
          "target_camera_y":-0.05168083844327382,
          "target_camera_z":0.2833486032092124,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Villa-Blanca",
          "depth": "20–40 ft (6–12 m)",
          "level": "Beginner",
          "location": "20.468952065438124, -86.98345874116492",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.22","Y":"0.02","Z":"-0.14","depth":"0.66","time":10}]
        },
        {



          "nombre_arrefice": "Colombia-Deep",
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Colombia-Deep",
          "position_camera_x":-0.4005936231477377,
          "position_camera_y":0.0455351669859049,
          "position_camera_z":0.3745275334534912,
          "target_camera_x":-0.1762280742254284,
          "target_camera_y":-0.16932199940679096,
          "target_camera_z":-0.017258758428310306,
          "isEuler": true,
          "depth": "60–100 ft (18–30 m)",
          "level": "Advanced",
          "location": "20.292107948062508, -87.02243146930691",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.38","Y":"-0.01","Z":"0.28","depth":"1.55","time":10}]
        },
        {




          "nombre_arrefice": "San-Clemente",
          "position_camera_x":-0.36652775467643034,
          "position_camera_y":0.03653136085952541,
          "position_camera_z":-0.008855030736876712,
          "target_camera_x":-0.31488861070039503,
          "target_camera_y":-0.12662067665196425,
          "target_camera_z":0.46094791887633274,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/San-Clemente",
          "depth": "20–40 ft (6–12 m)",
          "level": "Beginner",
          "location": "20.406978304504356, -87.0227192219262",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.35","Y":"-0.01","Z":"0.05","depth":"1.83","time":10}]
        },
        {
          "nombre_arrefice": "Maracaibo",
          "position_camera_x":-0.616316181165592,
          "position_camera_y":0.05009514227443956,
          "position_camera_z":0.45262876270127916,
          "target_camera_x":-0.2320925802952665,
          "target_camera_y":-0.030462302791403023,
          "target_camera_z":0.1429848639964359,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Maracaibo",
          "depth": "50–90 ft (15–27 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "",
          "medidas_largo": 750,
          "rutas": []
        },
        {
          "nombre_arrefice": "Punta-Sur",
          "position_camera_x":-0.616316181165592,
          "position_camera_y":0.05009514227443956,
          "position_camera_z":0.45262876270127916,
          "target_camera_x":-0.2320925802952665,
          "target_camera_y":-0.030462302791403023,
          "target_camera_z":0.1429848639964359,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Punta-Sur",
          "depth": "50–90 ft (15–27 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "",
          "medidas_largo": 750,
          "rutas": []
        },
        {



          "nombre_arrefice": "C53-Felipe-Xicotencatl",
          "position_camera_x":-0.347412668636936,
          "position_camera_y":0.03880146651433164,
          "position_camera_z":0.009071644065289208,
          "target_camera_x":0.019077202765303156,
          "target_camera_y":-0.07572011478069277,
          "target_camera_z":-0.31119384201970457,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/mobil_joystick/C53-Felipe-Xicotencatl",
          "depth": "50–90 ft (15–27 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.442677952960302, -87.00093693493648",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.29","Y":"0.02","Z":"-0.03","depth":"0.90","time":10}]
        },
        {

       

          "nombre_arrefice": "San-Francisco",
          "position_camera_x":-0.41264520632523294,
          "position_camera_y":0.026700240694638472,
          "position_camera_z":0.11534719319864156,
          "target_camera_x":-0.05074700999427693,
          "target_camera_y":-0.1317534428623393,
          "target_camera_z":-0.19111997577648038,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/San-Francisco",
          "depth": "50–90 ft (15–27 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.390604, -87.027598",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.37","Y":"-0.01","Z":"0.09","depth":"2.30","time":10}]
        },
        {




          "nombre_arrefice": "Tunich",
          "position_camera_x":-0.36652775467643034,
          "position_camera_y":0.03653136085952541,
          "position_camera_z":-0.008855030736876712,
          "target_camera_x":-0.31488861070039503,
          "target_camera_y":-0.12662067665196425,
          "target_camera_z":0.46094791887633274,
          "isEuler": true,
          "url_full_map": "https://cozumel-reef-maps.com.mx/Index/reef/Tunich",
          "depth": "50–90 ft (15–27 m)",
          "level": "Intermediate to advanced; some areas accessible to beginners with supervision.",
          "location": "20.406914401420682, -87.02359594277223",
          "medidas_largo": 750,
          "rutas": [{"X":"-0.37","Y":"-0.01","Z":"0.07","depth":"2.61","time":10}]
        }
      ]



};


// 1. Caso especial: "all_points"
    if (nombre.toLowerCase() === "all_points") {
        return array_madre.reefs.map(r => ({
            nombre_arrefice: r.nombre_arrefice,
            rutas: r.rutas
        }));
    }

    // 2. Caso estándar: Búsqueda aproximada del arrecife
    const nombreMin = nombre.toLowerCase().replace(/-/g, " ");
    const resultado = array_madre.reefs.find(r => {
        const arrecifeMin = r.nombre_arrefice.toLowerCase().replace(/-/g, " ");
        return arrecifeMin.includes(nombreMin) || nombreMin.includes(arrecifeMin);
    });

    if (resultado) {
        // Clonamos para no corromper la base de datos original (array_madre)
        const arrecifeClonado = JSON.parse(JSON.stringify(resultado));
        
        // Usamos la función exclusiva para modificar la información de la copia
        actualizarCoordenadasConMarcador(arrecifeClonado);

        return arrecifeClonado;
    }

    return null;


}



export function put_geometry_all_reefs(){

      return buscarArrecife("all_points");

}






/**
 * Busca un marcador aproximado en marcadoresRutas y actualiza las coordenadas de la ruta del arrecife.
 * @param {Object} arrecife - El objeto del arrecife a modificar.
 */
function actualizarCoordenadasConMarcador(arrecife) {
    if (!arrecife || !arrecife.rutas || arrecife.rutas.length === 0) return;

    // 1. Limpieza total del JSON: pasamos a minúsculas, quitamos guiones medios Y guiones bajos
    const nombreArrecifeLimpio = arrecife.nombre_arrefice
        .toLowerCase()
        .replace(/-/g, " ")
        .replace(/_/g, " ")
        .trim();

    // 2. Buscamos en el array global aplicando exactamente la misma limpieza estricta
    const marcadorAsociado = marcadoresRutas.find(m => {
        const nombreMarcadorLimpio = m.nombre_reef
            .toLowerCase()
            .replace(/-/g, " ")
            .replace(/_/g, " ")
            .trim();
        
        // Coincidencia exacta o aproximada
        return nombreArrecifeLimpio.includes(nombreMarcadorLimpio) || nombreMarcadorLimpio.includes(nombreArrecifeLimpio);
    });

    // 3. Si existe, aplicamos el cambio
    if (marcadorAsociado && marcadorAsociado.letrero) {
        const posicionLetrero = marcadorAsociado.letrero.position;

        arrecife.rutas[0].X = posicionLetrero.x.toString();
        arrecife.rutas[0].Y = posicionLetrero.y.toString();
        arrecife.rutas[0].Z = posicionLetrero.z.toString();

        console.log(`✅ [ACTUALIZADO] ${arrecife.nombre_arrefice} con éxito a X:${arrecife.rutas[0].X}`);
    } else {
        // 🛑 Agrega este log temporal para ver exactamente cuál está fallando en consola
        console.warn(`❌ [ERROR DE VINCULACIÓN] No se encontró marcador 3D para el JSON: "${arrecife.nombre_arrefice}"`);
    }
}




export const marcadoresRutas = [];

/**
 * Crea el sensor y letrero para un Mesh real detectado en la escena.
 * @param {THREE.Mesh} reefMesh - El objeto 3D real de la escena (child)
 * @param {THREE.Scene} escena - Instancia de la escena.
 */
export function vincularMarcadorAlReef(reefMesh, escena) {
    reefMesh.updateMatrixWorld(true);

    const box = new THREE.Box3().setFromObject(reefMesh);
    const centro = new THREE.Vector3();
    box.getCenter(centro);

    const nombreLimpio = reefMesh.name
        .replace("REEF_", "")
        .replace(/_/g, " ");

    // Creamos el letrero dinámico pasando el texto y el string SVG por separado
    const labelSprite = crearLetreroTexto(nombreLimpio, svg.dive);

    // Posicionamos el letrero en el centro del Reef
    labelSprite.position.copy(centro);
    
    // --- MODIFICACIÓN: Ajustamos la altura de flotación (Y) ya sin el cubo ---
    labelSprite.position.y += 0.0025; 

    labelSprite.visible = true;

    // Agregamos solo el letrero a la escena
    escena.add(labelSprite);

    // Guardamos la referencia (adaptado por si lo usas en otra parte de tu lógica)
    marcadoresRutas.push({
        letrero: labelSprite,
        nombre_reef: nombreLimpio
    });

    console.log("[REEF CENTRO]", nombreLimpio, centro);
}

export function crearLetreroTexto(texto, svgString) {
    const textoLimpio = texto.replace(/-/g, " ");

    // 1. CREACIÓN DE UN CANVAS TEMPORAL PARA MEDIR EL TEXTO
    const canvasMedición = document.createElement("canvas");
    const ctxMedición = canvasMedición.getContext("2d");
    ctxMedición.font = "bold 18px sans-serif";
    
    // Medimos cuántos píxeles ocupa el texto real
    const metrics = ctxMedición.measureText(textoLimpio);
    
    // Configuración de dimensiones para el Icono SVG
    const iconSize = 18; 
    const iconPadding = 8; // Espacio entre el icono y el texto
    const paddingX = 24;   // Márgenes totales en los extremos izquierdos/derechos
    
    // El ancho ahora contempla: Margen + Tamaño Icono + Espacio IconoTexto + Ancho Texto + Margen
    const canvasWidth = Math.max(64, metrics.width + iconSize + iconPadding + paddingX); 
    const canvasHeight = 32; // --- MODIFICACIÓN: Canvas más compacto en altura (de 48 a 32) ---

    // 2. CREACIÓN DEL CANVAS REAL CON EL ANCHO EXACTO Y DINÁMICO
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // 3. MAPEAR TEXTURA Y APLICAR ESCALA REDUCIDA INICIALMENTE (Vacio/Transparente)
    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: false
    });

    const sprite = new THREE.Sprite(spriteMaterial);

    // --- MODIFICACIÓN: Reducción del tamaño final en el mundo 3D ---
    const escalaBaseY = 0.0035; 
    const relacionAspecto = canvasWidth / canvasHeight;
    const escalaBaseX = escalaBaseY * relacionAspecto;

    sprite.scale.set(escalaBaseX, escalaBaseY, 1);

    // 4. CARGAR RENDERIZADO DEL SVG ASÍNCRONAMENTE
    const img = new Image();
    // Codificamos de manera segura el string XML del SVG para usarlo como URL
    img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);

    img.onload = function() {
        // Redibujamos todo el contenedor una vez que la imagen esté lista para evitar parpadeos
        
        // 4.1. DIBUJAR EL FONDO REDONDEADO DINÁMICO
        ctx.fillStyle = "rgba(0,15,25,0.85)";
        ctx.strokeStyle = "#00ffcc";
        ctx.lineWidth = 1.5; 

        const rectX = 1;
        const rectY = 1;
        const rectW = canvasWidth - 2;
        const rectH = canvasHeight - 2;
        const radioCórner = 6; 

        if (ctx.roundRect) {
            ctx.beginPath();
            ctx.roundRect(rectX, rectY, rectW, rectH, radioCórner);
            ctx.fill();
            ctx.stroke();
        } else {
            ctx.fillRect(rectX, rectY, rectW, rectH);
            ctx.strokeRect(rectX, rectY, rectW, rectH);
        }

        // 4.2. DIBUJAR EL ICONO SVG EN EL CANVAS
        // Calculamos la coordenada X de inicio para centrar el bloque (Icono + Espacio + Texto)
        const totalContentWidth = iconSize + iconPadding + metrics.width;
        const startX = (canvasWidth - totalContentWidth) / 2;
        const iconY = (canvasHeight - iconSize) / 2;

        ctx.drawImage(img, startX, iconY, iconSize, iconSize);

        // 4.3. DIBUJAR EL TEXTO PERFECTAMENTE ALINEADO AL ICONO
        ctx.font = "bold 18px sans-serif"; 
        ctx.fillStyle = "#ffffff";
        ctx.textAlign = "left"; // Cambiado a 'left' para iniciar exactamente después del icono
        ctx.textBaseline = "middle";
        
        const textoX = startX + iconSize + iconPadding;
        ctx.fillText(textoLimpio, textoX, canvasHeight / 2);

        // 4.4. INFORMAR A THREE.JS QUE DEBE VOLVER A CARGAR EL CANVAS EN LA GPU
        texture.needsUpdate = true;
    };

    return sprite;
}